import { BlogSection } from '@/types/blog';

export const katalysatorMethode: BlogSection = {
  id: 'katalysator-methode',
  title: 'Die Katalysator-Methode: Wo drückt der Schuh?',
  content: `
<p>Mein Werkzeugkasten ist keine Sammlung von Standardrezepten. In der Chemie verändert ein Katalysator die Bedingungen so, dass eine Reaktion leichter stattfinden kann. Genau das ist mein Ansatz in der Unternehmenskultur und im Einzelcoaching:</p>

<h3>Resonanz statt Skripte</h3>
<p>Wir arbeiten nicht nach Plan A oder B. Wir gehen dorthin, wo der Schuh drückt. Im Gespräch finden wir heraus, ob es die kognitive Komplexität ist – das strategische Denken auf mehreren Ebenen – oder ob emotionale Dynamiken im Team die notwendige Aktivierungsenergie nach oben treiben.</p>

<h3>Entwicklung der Unternehmenskultur</h3>
<p>Echte Veränderung entsteht nicht durch Anweisung, sondern durch die Arbeit an der Basis. Wir nutzen systemische Ansätze, um Blockaden in der Kommunikation und Entscheidungsfindung sichtbar zu machen.</p>

<h3>Wissenschaftliches Fundament</h3>
<p>Wir stützen uns auf die <strong>Polyvagal-Theorie</strong> von Stephen Porges, um das Nervensystem wieder in die Sicherheit zu führen. Zudem nutzen wir Erkenntnisse über <strong>Entscheidungsmüdigkeit</strong> (Baumeister et al.), um Prozesse zu verschlanken. Das Ziel ist eine evidenzbasierte Begleitung ohne Esoterik.</p>
  `
};
